// Purchase orders — direct Supabase (no legacy financialAuth gate)
import { supabase } from '@/lib/customSupabaseClient';

export interface PurchaseOrderRow {
  id: string;
  tenant_id: string;
  po_number: string | null;
  vendor_id: string | null;
  vendor_name: string | null;
  order_date: string | null;
  expected_delivery_date: string | null;
  status: string;
  subtotal: number | null;
  tax_amount: number | null;
  shipping_amount: number | null;
  total_amount: number | null;
  currency: string | null;
  notes: string | null;
  is_active: boolean | null;
  created_at: string;
  updated_at: string | null;
}

export interface ApiResult<T> {
  success: boolean;
  data?: T;
  error?: string;
}

function errMsg(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: string }).message);
  }
  return error instanceof Error ? error.message : 'Unknown error';
}

export async function listPurchaseOrders(filters?: {
  search?: string;
  status?: string;
}): Promise<ApiResult<PurchaseOrderRow[]>> {
  try {
    let query = supabase
      .from('purchase_orders')
      .select('*')
      .or('is_active.is.null,is_active.eq.true')
      .order('order_date', { ascending: false });

    if (filters?.status && filters.status !== 'all') {
      query = query.eq('status', filters.status);
    }
    if (filters?.search?.trim()) {
      const s = filters.search.trim().replace(/[%_]/g, '');
      query = query.or(`po_number.ilike.%${s}%,vendor_name.ilike.%${s}%,notes.ilike.%${s}%`);
    }

    const { data, error } = await query;
    if (error) throw error;
    return { success: true, data: (data || []) as PurchaseOrderRow[] };
  } catch (error) {
    return { success: false, error: errMsg(error) };
  }
}